import { endpoint } from '@library/endpoint'

import { fetch } from 'utils/fetch'

export function fetchRecipeStock(accessToken, deliveryDayId) {
  return fetch(accessToken, `${endpoint('core')}/delivery_day/${deliveryDayId}/stock`, {}, 'GET')
}
